import { Alert, Backdrop, Button, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PuffLoader } from 'react-spinners';
import { apiAction } from '../../constants/Constant';
import { IGetAPIDocument } from '../../models/APITransationLog/IAPITransationLog';
import { useGlobalState } from '../../store/GlobalStore';
import { useFetch, usePost } from '../../utils/apiHelper';
import useStyles from '../GlobalStyles/DocumentCss';

const DownloadAPIDocument = () => {
    const classes = useStyles();
    const { state } = useGlobalState();
    const [progressBar, setshowProgressBar] = useState(false);
    const [fileExists, setFileExists] = useState(false);
    const [apiDocumentList, setAPIDocumentList] = useState<IGetAPIDocument[]>([]);

    useEffect(() => {
        handleFetchAPIDocument();
    }, []);

    const DownloadFileAsync = () => {
        setshowProgressBar(true);
        if (apiDocumentList?.length > 0) {
            (async () => {
                await usePost<any>(`File/DownloadFileFromBlob?blobUri=${apiDocumentList[0]?.blobUri}`, null).then((r) => {
                    const arrayBuffer = base64ToArrayBuffer(r.data);
                    createAndDownloadBlobFile(arrayBuffer, apiDocumentList[0]?.fileName);
                }).catch(() => {
                    setFileExists(true);
                }).finally(() => {
                    setshowProgressBar(false);
                    InsertAPIDocumentHistory()
                });
            })();
        }
    }

    const InsertAPIDocumentHistory = () => {
        setshowProgressBar(true);
        (async () => {
            let request = {
                "documentId": apiDocumentList[0]?.documentId,
                "userId": state.userAccessContext.id,
                "actionId": apiAction.Downloaded.toString()
            }
            await usePost<any>("History/InsertAPIDocumentHistory", request).then((r) => {
            }).finally(() => {
                setshowProgressBar(false);
            })
        })()
    }

    function base64ToArrayBuffer(base64: string) {
        const binaryString = window.atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
    }

    function createAndDownloadBlobFile(body, filename) {
        const blob = new Blob([body]);
        const fileName = `${filename}`;
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const closeSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setFileExists(false);
    };

    const handleFetchAPIDocument = () => {
        setshowProgressBar(true);
        (async () => {
            await useFetch<IGetAPIDocument[]>("History/GetAPIDocumentDetails").then((result) => {
                setAPIDocumentList(result?.data);
            });
        })().finally(() => {
            setshowProgressBar(false);
        });
    }

    return (
        <React.Fragment>
            <Button variant='contained' onClick={DownloadFileAsync} size='small' sx={{ mt: '5px' }}>Download API Document</Button>

            <Backdrop className={classes.backdrop} open={progressBar}>
                <PuffLoader size={80} color={"white"} speedMultiplier={1} />
            </Backdrop>

            <Snackbar open={fileExists} className="snackBarStyle" anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={() => closeSnackbar()}>
                <Alert onClose={() => closeSnackbar()} severity="error" className="alertStyle">
                    File does not exists!
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}

export default DownloadAPIDocument